import React from 'react'
import { PieChart, Pie, ResponsiveContainer, Cell, Sector } from 'recharts'


class Chart extends React.Component {
    constructor(props) {
        super(props)

        this.state = { activeIndex: 0 }
    }

    renderActiveShape = ({
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        fill,
        payload,
        percent,
        value,
    }) =>  {
        const { size = 1 } = this.props
        const name = payload.name.length  > 25   ? payload.name.substring(0,20) + "..." : payload.name

        return (
            <g>
                <text
                    x={cx}
                    y={cy - innerRadius/2}
                    textAnchor="middle"
                    fill={'#9E9E9E'}
                    fontSize={innerRadius / 8}>
                    Cost / Usage
                </text>
                <text
                    x={cx}
                    y={cy}
                    textAnchor="middle"
                    fill={'#212121'}
                    fontSize={innerRadius / 2.3}>
                    {payload.percent}
                </text>
                <line
                    x1={cx - 30  }
                    y1={cy + (innerRadius / 7)  }
                    x2={cx + 30  }
                    y2={cy + (innerRadius / 7) }
                    stroke="#9E9E9E"
                    strokeWidth={`${innerRadius / 33}px`}
                />
                <text
                    x={cx}
                    y={cy + (innerRadius / 2.5) }
                    textAnchor="middle"
                    fill="#212121"
                    fontSize={innerRadius / 6}>
                    {payload.cost}
                </text>
                <text
                    x={cx}
                    y={cy + innerRadius / 1.5   }
                    textAnchor="middle"
                    fill="#9E9E9E"
                    fontSize={innerRadius / 8}>
                    {name}
                </text>

                <Sector
                    cx={cx}
                    cy={cy}
                    innerRadius={innerRadius - 2  }
                    outerRadius={outerRadius + 2  }
                    startAngle={startAngle}
                    endAngle={endAngle}
                    fill={fill}
                />
            </g>
        )
    }

    render() {
        const { data, colors, activeIndex, setActiveCell, height, width, innerRadius, outerRadius, size = 1 } = this.props
        return (
            <div className="chart-container">
            <ResponsiveContainer  debounce={1}>
                <PieChart>
                    <Pie
                        activeIndex={activeIndex}
                        activeShape={this.renderActiveShape}
                        data={data}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        innerRadius="89%"
                        outerRadius="100%"
                        fill="#8884d8">
                        {data.map((entry, index) => (
                            <Cell
                                key={index}
                                fill={colors[index % colors.length]}
                                onClick={() => setActiveCell(index)}
                            />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
            </div>
        )
    }
}

export default Chart